import React from "react";
import { Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

import './headBar.css'
import logoWhite from '../../image/logo/logoWhite.svg'
import QWhite from '../../image/logo/QWhite.svg'
import { useNavigate } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";

interface HeadBarProps {
    textBackButton?:string,
    title:string,
    link?:string,
    makeModif?:() => void,
    hasLogo?:boolean,
}

const HeadBar:React.FC<HeadBarProps> = ({textBackButton,link,title,hasLogo=true,makeModif}) => {
    const navigate = useNavigate()
   const handleClick = () => {
    if (makeModif) {
        makeModif();
    } else {
        if (link === "back") {
            navigate(-1); 
        } else if (link) {
            navigate(link); 
        }
    }
};


return (
    <div className='containerHeadBar' > 

        {link && (
            <>
                {textBackButton && (
                    <div className="smallText pointer backButton lowOpacityHover backButtonDesktop" onClick={handleClick}>
                        <BsArrowLeft className="pointer" size={20} /> 
                        <p>{textBackButton}</p> 
                    </div>
                )}

                <div className="pointer backButtonMobile" onClick={handleClick}>
                    <FiChevronLeft size={28} />
                </div>
            </>
        )}

        <p className="title largeTitle">{title}</p>

        {hasLogo && <>
            <Link to='/' className='pointer logoWrapper'>
                <img src={logoWhite} className="logo" loading="lazy" alt="logo"/>
            </Link>

            <Link to='/' className='pointer logoQWrapper'>
                <img src={QWhite} className="logo" loading="lazy" alt="logo"/>
            </Link>
        </>}

    </div>
)

}


export default HeadBar